import Highcharts from 'react-highcharts';
import * as cookies from './Cookies';
import * as defaultValue from '../constants/common/ConstDefaultValue';
import * as dispTypes from '../constants/common/ConstDispTypes';
import * as InfoMessage from '../constants/common/InfoMessage';
import * as apiWrapper from '../logic/APIWrapper';

export const FROM_DATE_KEY = 'fromDate';
export const TO_DATE_KEY = 'toDate';

/**
 * API呼び出し予定時間取得
 */
export function getAPICallPlanTime() {
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return time;
}

/*
リストボックス用ダミーデータ
 */
export function createItemList() {
  const itemList = [];
  const kubunList = [];
  const rateList = [];
  const typeList = [];
  const dummy = [{ id: 0, display_name: '' }];
  const syubetsuDummy = [{ id: 0, display_name: '', ps: '' }];
  const kishuDummy = { data: [{ id: 0, display_name: ' ' }] };
  const goukiDummy = [];
  const yugitypeDummy = [];
  const smartFlagDummy = [];

  // 区分リスト
  kubunList.allList = dummy;
  kubunList.pachinkoList = dummy;
  kubunList.slotList = dummy;

  itemList.kubunList = kubunList;
  // 種別リスト
  itemList.shubetsuList = syubetsuDummy;
  // レートリスト
  rateList.pachinkoList = dummy;
  rateList.slotList = dummy;

  itemList.rateList = rateList;
  // メーカーリスト
  itemList.makerList = dummy;
  // タイプリスト
  typeList.pachinkoList = dummy;
  typeList.slotList = dummy;

  itemList.typeList = typeList;
  // 機種名リスト
  itemList.kishuNameList = kishuDummy;

  // 号機リスト
  itemList.goukiList = goukiDummy;

  // 遊技タイプリスト
  itemList.yugitypeList = yugitypeDummy;

  // スマート遊技機リスト
  itemList.smartFlagList = smartFlagDummy;

  return itemList;
}

/**
 * URLアンカーのaccess_tokenを取得
 */
export function getAccessTokenFromURL() {
  const urlParam = getAnchorString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.access_token == null) {
    return null; // default
  }
  return urlParam.access_token;
}

/**
 * URLアンカーのid_tokenを取得
 */
export function getIdTokenFromURL() {
  const urlParam = getAnchorString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.id_token == null) {
    return null; // default
  }
  return urlParam.id_token;
}

/**
 * URLアンカーのstateを取得
 */
export function getStateFromURL() {
  const urlParam = getAnchorString();
  if (urlParam == null) {
    return null;
  }
  if (urlParam.state == null) {
    return null;
  }
  return urlParam.state;
}

/**
 * URLアンカーのerrorを取得
 */
export function getErrorFromURL() {
  const urlParam = getAnchorString();
  if (urlParam == null) {
    return null;
  }
  if (urlParam.error == null) {
    return null;
  }
  return urlParam.error;
}

/**
 * URLアンカーのerror_descriptionを取得
 */
export function getErrorDescriptionFromURL() {
  const urlParam = getAnchorString();
  if (urlParam == null) {
    return null;
  }
  if (urlParam.error_description == null) {
    return null;
  }
  return urlParam.error_description;
}


/**
 * URLパラメータのTermを取得
 */
export function getTermFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.term == null) {
    return null; // default
  }
  return urlParam.term;
}

/**
 * URLパラメータのShubetsuを取得
 */
export function getShubetsuFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_SHUBETSU; // default
  }
  if (urlParam.shubetsu == null) {
    return defaultValue.DEFAULT_SHUBETSU; // default
  }
  return urlParam.shubetsu;
}

/**
 * 最新週のキーを取得
 */
export function getLastTermKey(termData) {
  if (termData != null && termData.length !== 0) {
    return termData[termData.length - 1].id;
  }
  return null;
}

/**
 * 12週前のキーを取得
 * @param {*} termData
 */
export function getBefore12WeekTermKey(termData) {
  return termData[termData.length - 12].id;
}

/**
 * URLパラメータのTypeFlgを取得
 */
export function getTypeFlg() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_DISP_TYPE; // default
  }
  if (urlParam.typeFlg == null) {
    return defaultValue.DEFAULT_DISP_TYPE; // default
  }
  return urlParam.typeFlg;
}

/**
 * URLパラメータのDispTypeを取得
 */
export function getDispType() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return dispTypes.DAYOFF_TYPEOFF; // default
  }
  if (urlParam.typeFlg == null) {
    return dispTypes.DAYOFF_TYPEOFF; // default
  }
  if (urlParam.typeFlg == 1) {
    return dispTypes.DAYOFF_TYPEON;
  }
  return dispTypes.DAYOFF_TYPEOFF; // default
}

/**
 * URLパラメータのPSを取得
 */
export function getPSKubun() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.PS_PACHINKO; // default
  }
  if (urlParam.ps == null) {
    return defaultValue.PS_PACHINKO; // default
  }
  return urlParam.ps;
}

/**
 * URLパラメータの区分を取得
 */
export function getKubunFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_KUBUN; // default
  }
  if (urlParam.partitions == null) {
    return defaultValue.DEFAULT_KUBUN; // default
  }
  return urlParam.partitions;
}

/**
 * URLパラメータの平日を取得
 */
export function getdayFlgFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_DAY; // default
  }
  if (urlParam.dayFlg == null) {
    return defaultValue.DEFAULT_DAY; // default
  }
  return urlParam.dayFlg;
}

/**
 * URLパラメータのレートを取得
 */
export function getRateFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_PACHI_RATE; // default
  }
  if (urlParam.rates == null) {
    if (getPSKubun() == 0) {
      return defaultValue.DEFAULT_PACHI_RATE; // default
    } else {
      return defaultValue.DEFAULT_SLOT_RATE; // default
    }
  }
  return urlParam.rates;
}

/**
 * URLパラメータの納品を取得
 */
export function getNohinURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.nohinkaishibi == null) {
    return null; // default
  }
  return urlParam.nohinkaishibi;
}

/**
 * URLパラメータの納品を取得
 */
export function getNohinFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.nohinkaishibiFrom == null) {
    return null; // default
  } else {
    if (urlParam.nohinkaishibiFrom == '指定なし') {
      return null; // default
    } else {
      return toHyphenFormatDate(urlParam.nohinkaishibiFrom);
    }
  }
}

/**
 * URLパラメータの納品を取得
 */
export function getNohinToURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.nohinkaishibiTo == null) {
    return null; // default
  } else {
    if (urlParam.nohinkaishibiTo == '指定なし') {
      return null; // default
    } else {
      return toHyphenFormatDate(urlParam.nohinkaishibiTo);
    }
  }
}

/**
 * URLパラメータのタイプを取得
 */
export function getTypeFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_TYPE; // default
  }
  if (urlParam.type == null) {
    return defaultValue.DEFAULT_TYPE; // default
  }
  return urlParam.type;
}

/**
 * URLパラメータのメーカを取得
 */
export function getMakerFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_MAKER; // default
  }
  if (urlParam.brands == null) {
    return defaultValue.DEFAULT_MAKER; // default
  }
  return urlParam.brands;
}

/**
 * URLパラメータの遊技タイプを取得
 */
export function getParamYugiType() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_YUGI_TYPE; // default
  }
  if (urlParam.yugitype == null) {
    return defaultValue.DEFAULT_YUGI_TYPE; // default
  }
  return urlParam.yugitype;
}
/**
 * URLパラメータの号機を取得
 */
export function getGoukiFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_GOUKI; // default
  }
  if (urlParam.gouki == null) {
    return defaultValue.DEFAULT_GOUKI; // default
  }
  return urlParam.gouki;
}

/**
 * URLパラメータのスマート遊技機を取得
 */
export function getSmartYugikiFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_SMARTYUGIKI; // default
  }
  if (urlParam.smartYugiki == null) {
    return defaultValue.DEFAULT_SMARTYUGIKI; // default
  }
  return urlParam.smartYugiki;
}

/**
 * URLパラメータの機種IDを取得
 */
export function getKishuIDFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return null; // default
  }
  if (urlParam.machineId == null) {
    return null; // default
  }
  return urlParam.machineId;
}

/**
 * URLパラメータの機種名を取得
 */
export function getKishuNameFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return ''; // default
  }
  if (urlParam.machineName == null) {
    return ''; // default
  }
  return urlParam.machineName;
}

/**
 * URLパラメータの期間タブを取得
 */
export function getKikanUnitFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_KIKAN_UNIT; // default
  }
  if (urlParam.kikanUnit == null) {
    return defaultValue.DEFAULT_KIKAN_UNIT; // default
  }
  return urlParam.kikanUnit;
}

/**
 * 表示形式（期間別 or 導入後推移）
 */
export function getDisplayGraphFormat() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_DISPLAY_GRAPH_FORMAT_K015; // default
  }
  if (urlParam.displayGraphFormat == null) {
    return defaultValue.DEFAULT_DISPLAY_GRAPH_FORMAT_K015; // default
  }
  return urlParam.displayGraphFormat;
}

/**
 * 期間（日間 or 週間）
 */
export function getGraphTermType() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.GRAPH_TYPE_DAILY; // default
  }
  if (urlParam.graphTermType == null) {
    return defaultValue.GRAPH_TYPE_DAILY; // default
  }
  return urlParam.graphTermType;
}

/**
 * 表示形式（曜日表示 or 経過日数表示）
 */
export function getDisplayFormat() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_DISPLAY_FORMAT; // default
  }
  if (urlParam.displayFormat == null) {
    return defaultValue.DEFAULT_DISPLAY_FORMAT; // default
  }
  return urlParam.displayFormat;
}

/**
 * 期間From
 */
export function getTermFrom() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_TERM_FROM; // default
  }
  if (urlParam.termFrom == null) {
    return defaultValue.DEFAULT_TERM_FROM; // default
  }
  return urlParam.termFrom;
}

/**
 * 期間To
 */
export function getTermTo() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_TERM_TO; // default
  }
  if (urlParam.termFrom == null) {
    return defaultValue.DEFAULT_TERM_TO; // default
  }
  return urlParam.termTo;
}

/**
 * URLパラメータの表示項目を取得
 */
export function getDisplayItemFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_DISPLAY_ITEM_K015; // default
  }
  if (urlParam.displayItem == null) {
    return defaultValue.DEFAULT_DISPLAY_ITEM_K015; // default
  }
  if (urlParam.displayItem == "") {
    return defaultValue.DEFAULT_DISPLAY_ITEM_K015; // default
  }
  return urlParam.displayItem;
}


/**
 * URLパラメータの損益分岐を取得
 */
export function getBunkiwariFromURL() {
  const urlParam = getQueryString();
  if (urlParam == null) {
    return defaultValue.DEFAULT_BUNKIWARI_K015; // default
  }
  if (urlParam.bunkiwari == null) {
    return defaultValue.DEFAULT_BUNKIWARI_K015; // default
  }
  return urlParam.bunkiwari;
}

/**
 * Date型をyyyy/MM/ddのString型で返す
 */
export function toLocaleString(date) {
  return [
    date.getFullYear(),
    ('0' + (date.getMonth() + 1)).slice(-2),
    ('0' + date.getDate()).slice(-2)
  ].join('/');
}

/**
 * String型のyyyy-MM-ddをyyyy/MM/ddに変換して返す
 */
export function toSlashFormatDate(str) {
  return str.replace(/-/g, '/');
}
/**
 * String型のyyyy/MM/ddをyyyy-MM-ddに変換して返す
 */
export function toHyphenFormatDate(str) {
  return str.replace(/\//g, '-');
}
/**
 * String型のyyyy-MM-ddをyyyy/MM/dd（曜日）に変換して返す
 */
export function toSlashFormatDay(str) {
  const DAYLIST = ['日', '月', '火', '水', '木', '金', '土'];
  const slashDate = toSlashFormatDate(str);
  const date = new Date(str);
  return slashDate + '（' + DAYLIST[date.getDay()] + '）';
}

/**
 * Date型をyyyy/MM/ddのString型で返す
 * @param {*} date
 */
export function toTermFormatString(date) {
  // 2017-07-09T00:00:00+09:00
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00+09:00`;
}

/**
 * 前1週間の日付を取得
 * @param {*} Date  "2017-04-03"
 * @param {*} Days
 * @return {*} Ndays前の日付リスト
 */
export function getBeforeWeekDate(termDate, days) {

  // 列 12月前 13*7 = 84 days
  let fromDate = new Date(termDate);
  let lastWeek = new Date(fromDate.getTime() - 1000 * 60 * 60 * 24 * parseInt(days, 10));
  let month = ('0' + (lastWeek.getMonth() + 1).toString()).slice(-2);
  let date = ('0' + lastWeek.getDate().toString()).slice(-2);
  let year = lastWeek.getFullYear();
  let weekDate = year + '-' + month + '-' + date;

  return weekDate;

}

/**
 * 次の1週間の日付を取得
 * @param {*} Date  "2017-04-03"
 * @param {*} Days
 * @return {*} Ndays後の日付リスト
 */
export function getNextWeekDate(termDate, days) {
  // 1週間 （7days）
  let fromDate = new Date(termDate);
  let nextWeek = new Date(fromDate.getTime() + 1000 * 60 * 60 * 24 * parseInt(days, 10));
  let month = ('0' + (nextWeek.getMonth() + 1).toString()).slice(-2);
  let date = ('0' + nextWeek.getDate().toString()).slice(-2);
  let year = nextWeek.getFullYear();
  let nextweekDate = year + '-' + month + '-' + date;

  return nextweekDate;

}

/**
 * 日付がISO形式か判定する
 * @param {*} dateString
 * @returns
 */
export function isISOWeekDate(dateString) {
  // `YYYY-WXX` または `YYYY-WXX-D` のISO週番号形式にマッチする正規表現
  const isoWeekRegex = /^\d{4}-W\d{2}$/;

  // 正規表現にマッチするかを確認
  return isoWeekRegex.test(dateString);
}

/**
 * 日付型文字列をISO形式(YYYY-WXX)に変換する
 * @param {*} dateString
 * @returns
 */
export function toISOWeekFormat(dateString) {
  const date = new Date(dateString.replace(/-/g, '/')); // '-' か '/' 区切りに対応
  const year = date.getFullYear();

  // 新年の最初の月曜日を含む週が「W01」となるため調整
  const jan4 = new Date(year, 0, 4);
  const weekStartDate = new Date(jan4.setDate(jan4.getDate() - jan4.getDay() + 1));
  const daysBetween = (date - weekStartDate) / (24 * 60 * 60 * 1000);

  const weekNumber = Math.floor(daysBetween / 7) + 1;
  const formattedWeek = weekNumber < 10 ? `0${weekNumber}` : weekNumber;

  return `${year}-W${formattedWeek}`;
}

/**
 * ISO表示の期間を年月日に変換
 *
 * @param {*} Date  "2021-W01"
 * @param {*} startDay 開始曜日(0: 日曜, 1: 月曜)
 *
 * @return {*} { year: 年, month: 月, day: 日 }
 */
export function isoWeekToDateValues(isoString, dayType = 0, dayOfWeek = 1) {
  // ISO形式の文字列を分割
  const [year, week] = isoString.split('-W').map(Number);

  // 1月4日の週の月曜日の日付を取得
  const jan4 = new Date(year, 0, 4);
  const jan4Day = jan4.getDay();

  // 1月4日がある週の月曜日の日付を計算
  const weekStart = new Date(jan4);
  weekStart.setDate(jan4.getDate() - (jan4Day === 0 ? 6 : jan4Day - 1));

  // `dayType` に基づくオフセットの計算
  let dayOffset;
  if (dayType === 0) {
    dayOffset = 0; // 週の開始（デフォルト：月曜日）
  } else if (dayType === 1) {
    dayOffset = 6; // 週の終了（日曜日）
  } else {
    dayOffset = dayOfWeek - 1; // 任意の曜日（引数で指定）
  }

  // ISO週番号に基づくターゲット日付を計算
  weekStart.setDate(weekStart.getDate() + (week - 1) * 7 + dayOffset);

  // YYYY/MM/DDの形式で結果を返却
  const yyyy = String(weekStart.getFullYear());
  const mm = String(weekStart.getMonth() + 1).padStart(2, '0');
  const dd = String(weekStart.getDate()).padStart(2, '0');

  return { year: yyyy, month: mm, day: dd };
}

/**
 * 特定日付から指定された期間(日、週、月、年)の前後の期間を取得する
 *
 * @param {*} targetDate 特定日付(YYYY-MM-DD)
 * @param {*} periodType 期間種別(0: 日, 1: 週, 2: 月, 3: 年)
 * @param {*} direction 前後の指定(0: 前期間, 1: 後期間)
 * @param {*} periodCount 取得する期間の数(例: 10 なら10個の期間)
 * @param {*} formatType 0: 年 (YYYY), 1: 月 (MM), 2: 日 (DD), 3: 年/月 (YYYY/MM), 4: 年/月/日 (YYYY/MM/DD), 5: 月/日 (MM/DD)
 *
 * @returns 前後N期間の配列
 */
export function getDateRange(targetDate, periodType, direction, periodCount, formatType) {
  // targetDateのハイフンをスラッシュに置き換え
  const normalizedDate = targetDate.replace(/-/g, '/');
  const dateParts = normalizedDate.split('/');
  const startDate = new Date(dateParts[0], dateParts[1] - 1, dateParts.length > 2 ? dateParts[2] : 1);
  const result = [];

  // 日付フォーマット関数
  const formatDate = (date, format) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    switch (format) {
      case 0: return `${yyyy}`;             // 年のみ
      case 1: return `${mm}`;               // 月のみ
      case 2: return `${dd}`;               // 日のみ
      case 3: return `${yyyy}/${mm}`;       // 年/月
      case 4: return `${yyyy}/${mm}/${dd}`; // 年/月/日
      case 5: return `${mm}/${dd}`;         // 月/日
      default: throw new Error('不正なフォーマットです');
    }
  };

  // 指定された日付を含む前後の範囲を取得
  for (let i = 0; i < periodCount; i++) {
    let currentDate;

    // 基準日を設定。日付を含むように1日分前または後に移動
    const offset = (direction === 0 ? -1 : 1) * i;

    if (periodType === 0) { // 日
      currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + offset);
      result.push(formatDate(currentDate, formatType));
    } else if (periodType === 1) { // 週
      currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + (7 * offset));
      const weekStart = new Date(currentDate);
      const weekEnd = new Date(currentDate);
      weekEnd.setDate(weekStart.getDate() + 6);
      result.push(`${formatDate(weekStart, formatType)}～${formatDate(weekEnd, formatType)}`); // 週範囲
    } else if (periodType === 2) { // 月
      currentDate = new Date(startDate);
      currentDate.setMonth(startDate.getMonth() + offset);
      result.push(formatDate(currentDate, formatType));
    } else {
      throw new Error('不正な期間種別です');
    }
  }

  return result;
}

/**
 * 日付変換
 *
 * @param {*} inputDate "2023-12-25" または "2023-12-25T00:00:00+09:00"
 * @param {*} formatType 0: "2023", 1: "2023-12", 2: "2023-W48", 3: "2023-12-01"
 * @returns 指定した日付
 */
export function formatDate(inputDate, formatType) {
  let year;
  let month;
  let day;
  if (isISOWeekDate(inputDate)) {
    // YYYY-WXX形式の場合
    let weekMap = isoWeekToDateValues(inputDate, 1);
    year = weekMap.year;
    month = weekMap.month;
    day = weekMap.day;
  } else {
    // 入力日付のフォーマットに対応（'YYYY-MM-DD' または 'YYYY-MM-DDTHH:mm:ss±hh:mm'）
    const [datePart] = inputDate.split('T'); // 'YYYY-MM-DD' 部分を抽出
    const dateMap = datePart.split('-').map(Number); // 年・月・日を分解
    year = dateMap[0];
    month = dateMap[1];
    day = dateMap[2];
  }

  switch (formatType) {
    case 0: // YYYY
      return year.toString();
    case 1: // YYYY-MM
      return `${year}-${String(month).padStart(2, '0')}`;
    case 2: { // YYYY-WXX
      // ローカルタイム(日本時間)でDateオブジェクトを生成
      const targetDate = new Date(year, month - 1, day);
      // ISO週番号の計算
      const dayOfWeek = (targetDate.getDay() + 6) % 7; // 月曜を0とする
      targetDate.setDate(targetDate.getDate() - dayOfWeek + 3); // 木曜日に調整

      const firstThursday = new Date(targetDate.getFullYear(), 0, 4);
      const firstThursdayDayOfWeek = (firstThursday.getDay() + 6) % 7;
      firstThursday.setDate(firstThursday.getDate() - firstThursdayDayOfWeek + 3);

      const weekNumber = Math.ceil((targetDate - firstThursday) / (7 * 86400000)) + 1;

      const isoYear = targetDate.getFullYear();
      const lastDayOfYear = new Date(isoYear, 11, 31);
      const lastThursday = new Date(lastDayOfYear.getTime() + (3 - ((lastDayOfYear.getDay() + 6) % 7)) * 86400000);
      const totalWeeks = Math.ceil(
        ((lastThursday - firstThursday) / 86400000 + 1) / 7
      );

      if (weekNumber > totalWeeks) {
        return `${isoYear + 1}-W01`;
      }

      return `${isoYear}-W${String(weekNumber).padStart(2, '0')}`;
    }
    case 3: // YYYY-MM-DD
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    default:
      throw new Error('Unsupported format type');
  }
}

/**
 * ISO形式の期間(YYYY-W99)形式から週の開始終了を取得する
 *
 * @param {*} termWeek 期間値(YYYY-W99)
 * @param {*} len 終了日数
 * @param {*} formatType 日付形式
 */
export function getWeekStartAndEnd(termWeek, range, formatType) {
  const weekMap = isoWeekToDateValues(termWeek);
  const targetDate = new Date(weekMap.year + '-' + weekMap.month + '-' + weekMap.day);  // 文字列を Date に変換
  const dateList = [];
  dateList.push(targetDate.toISOString().split('T')[0]);

  for (let i = 1; i < range; i++) {
    targetDate.setDate(targetDate.getDate() + 1);
    dateList.push(formatDate(targetDate.toISOString(), formatType));
  }

  return dateList;
}

/**
 * getK007ParaItems
 */
export function getK007ParaItems(shubetsuList, shubetsuId) {

  let tmpShubetsuList = getShubetsu(shubetsuList);
  let item = tmpShubetsuList.filter((item) => {
    return (item.id == shubetsuId);
  });
  return item;
}

/**
 * 準必須チェック(K007, K011, K012)
 * @param {*} state
 */
export function checkJunHissu(state) {
  let nohinkaishibi = state.nohinkaishibi;
  let type = state.type;
  let maker = state.maker;
  let kishu = state.kishu;

  if ((nohinkaishibi == 'all' && type == defaultValue.DEFAULT_TYPE && maker == defaultValue.DEFAULT_MAKER) && (kishu == null || kishu == '')) {
    return true;
  } else {
    return false;
  }
}

/**
 * 準必須チェック(K008,K009,K010)
 * @param {*} state
 */
export function checkJunHissuOtherKishu(state) {
  let nohinkaishibi = state.nohinkaishibi;
  let type = state.type;
  let maker = state.maker;

  if (nohinkaishibi == 'all' && type == defaultValue.DEFAULT_TYPE && maker == defaultValue.DEFAULT_MAKER) {
    return true;
  } else {
    return false;
  }
}

/**
 * 準必須チェック(K013)
 * @param {*} state
 */
export function checkJunHissuAddList(state) {
  let nohinkaishibi = state.nohinkaishibi;
  let type = state.type;
  let maker = state.maker;
  let kishu = state.kishu;

  if ((nohinkaishibi == 'all' && type == defaultValue.DEFAULT_TYPE && maker == defaultValue.DEFAULT_MAKER) && (kishu == null || kishu == '')) {
    return false;
  } else {
    return true;
  }
}

/**
 * 最新週の納品開始日を取得
 */
export function getLastNohinDate(nohintermData) {
  if (nohintermData != null && nohintermData.data.length !== 0) {
    const nohinbi = nohintermData.data[0].model.nohinkaishibi; // 納品開始日を取得
    return nohinbi;
  }
  return null;
}

/**
 * 最新週のキーを取得
 */
export function getLastNohinTermKey(nohintermData) {
  if (nohintermData != null && nohintermData.data.length !== 0) {
    const nohinbi = nohintermData.data[0].model.nohinkaishibi; // 納品開始日を取得
    const kaishibi = nohinbi.split('-'); // 年月日をそれぞれ取得
    return kaishibi[0];
  }
  return null;
}


/**
 * 選択機種の納品開始日を取得
 */
export function getNohinkaishibiByKishu(kishuData) {
  if (kishuData != null && kishuData.length !== 0) {
    const nohinbi = kishuData.nohinkaishibi; // 納品開始日を取得
    const kaishibi = nohinbi.split('-'); // 年月日をそれぞれ取得
    return kaishibi[0];
  }
  return null;
}

/**
 * 日間データの表示状態情報を設定
 *
 * NOTE
 * 表示期間（期間開始 - 終了）の要素を持つ配列を作成する
 * 初週の日間データを表示しておく
 * 1～14週を選択した場合:
 *   [
 *     {week:1, isDayDataView: true}
 *     {week:2, isDayDataView: false}
 *     ・・・
 *     {week:14, isDayDataView: false}
 *   ]
 * 2～3週を選択した場合 [2,3]
 *   [
 *     {week:2, isDayDataView: true}
 *     {week:3, isDayDataView: false}
 *   ]
 */
export const setWeekIndexDailyDataControl = (termFrom, termTo) => {
  return Array.from({ length: termTo - termFrom + 1 }, (_, index) => ({
    week: termFrom + index,
    isDayDataView: index === 0
  }));
};

/**
 * APIパラメータエラー箇所を設定
 * @param {*} controlErr
 */
export function setControlError(controlErr) {
  let errArr = [];
  if (controlErr != null) {
    // 集計区分
    if (controlErr.indexOf('`partition`') != -1) {
      errArr.push(InfoMessage.KUBUN_ERROR);
    }
    // 期間
    if (controlErr.indexOf('`term`') != -1) {
      errArr.push(InfoMessage.CALENDER_ERROR);
    }
    // 種別
    if (controlErr.indexOf('`id`') != -1) {
      errArr.push(InfoMessage.SHUBETSU_ERROR);
      errArr.push(InfoMessage.KISHU_ERROR);
    }
    // レート
    if (controlErr.indexOf('`rate`') != -1) {
      errArr.push(InfoMessage.RATE_ERROR);
    }
    // タイプ
    if (controlErr.indexOf('`type`') != -1) {
      errArr.push(InfoMessage.TYPE_ERROR);
    }
    // メーカー
    if (controlErr.indexOf('`brand`') != -1) {
      errArr.push(InfoMessage.MAKER_ERROR);
    }
    // 機種名
    if (controlErr.indexOf('`q`') != -1) {
      errArr.push(InfoMessage.KISHU_TEXT_ERROR);
    }
    // 機種ID
    if (controlErr.indexOf('`model`') != -1) {
      errArr.push(InfoMessage.KISHU_ERROR);
    }
    // 納品開始日
    if (controlErr.indexOf('`nohinkaishi`') != -1) {
      errArr.push(InfoMessage.NOHINKAISHIBI_ERROR);
    }
  }
  return errArr;
}

/**
 * termから開始日／終了日を返す
 * @param {*} controlErr
 */
export function getTermDate(term, termData) {

  let termStart;
  let termEnd;
  let dates = [];

  if (term.length === 4) {  // 年を選択した場合
    termStart = term + '-01-01';
    termEnd = term + '-12-31';
  } else if ((term.length === 6 || term.length === 7) && term.match(/W/) == null) {  // 月を選択した場合
    termStart = term + '-01';
    const year = term.split('-')[0];
    const month = term.split('-')[1];
    const monthEnd = new Date(year, month, 0).getDate();
    termEnd = `${term}-${monthEnd}`;

  } else if ((term.length === 7 || term.length === 8) && term.match(/W/) != null) {  // 週を選択した場合
    let termDates = termData.filter((key) => {
      return (key.id == term);
    });

    if (termDates[0] != null) {
      let startDate = new Date(termDates[0].from_date);
      let endDate = new Date(termDates[0].to_date);

      termStart = startDate.getFullYear().toString() + '-' + ('0' + (startDate.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + startDate.getDate().toString()).slice(-2);
      termEnd = endDate.getFullYear().toString() + '-' + ('0' + (endDate.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + endDate.getDate().toString()).slice(-2);
    } else {
      // 期間カレンダーより表示中の年月を取得(/区切り)
      const displayYearMonth = $('.box_wrap').children('#c1_table_w').children('caption').children('.cal_cap_dev').children('.hid').text();
      if (displayYearMonth != null && displayYearMonth != 'NaN/aN') {
        let yearStart = displayYearMonth.substr(0, 4); // 開始年
        let yearEnd = displayYearMonth.substr(0, 4); // 終了年
        let monthStart = displayYearMonth.substr(5, 6); // 開始月
        let monthEnd = displayYearMonth.substr(5, 6); // 終了月
        // 期間カレンダーで選択されている週を取得
        const selectWeek = ($('#c1_table_w').children('tbody').children('tr').children('td'));
        let weekStart; // 選択週の月曜日
        let weekEnd; // 選択週の日曜日

        for (let i = 0; i < selectWeek.length; i++) {
          if (selectWeek[i].style.cssText == 'background: rgb(146, 208, 0);' ||
            selectWeek[i].style.cssText == 'background-color: rgb(146, 208, 0);') {
            if ($(selectWeek[i]).hasClass('cal_left')) {
              weekStart = selectWeek[i].innerHTML;
            }
            if ($(selectWeek[i]).hasClass('sun')) {
              weekEnd = selectWeek[i].innerHTML;
            }
          }
        }

        // 1~9日が選択されている場合は0埋め
        if (0 < parseInt(weekStart, 10) && parseInt(weekStart, 10) < 10) {
          weekStart = '0' + parseInt(weekStart, 10);
        }
        if (0 < parseInt(weekEnd, 10) && parseInt(weekEnd, 10) < 10) {
          weekEnd = '0' + parseInt(weekEnd, 10);
        }
        termStart = yearStart + '-' + monthStart + '-' + weekStart;
        termEnd = yearEnd + '-' + monthEnd + '-' + weekEnd;
      } else {
        // // TODO: 画面遷移でキーを引き継いだ際に該当するfrom_date, to_dateを取得できなかった場合
        // let startDate = new Date(termData[1].from_date);
        // let endDate = new Date(termData[1].to_date);

        // termStart = startDate.getFullYear().toString() + '-' + ('0' + (startDate.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + startDate.getDate().toString()).slice(-2);
        // termEnd = endDate.getFullYear().toString() + '-' + ('0' + (endDate.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + endDate.getDate().toString()).slice(-2);
      }
    }
  }
  if (termStart != null) {
    dates.push(termStart.replace(/-/g, '/'));
  }
  if (termEnd != null) {
    dates.push(termEnd.replace(/-/g, '/'));
  }
  return dates;
}

/**
 * 種別のAPIデータを整形する
 */
export function getShubetsu(data) {

  let newData = [];
  // データが取得できている場合
  if (data != null) {

    // 取得件数分ループする
    for (let i = 0; i < data.length; i++) {

      // 種別のレコード
      let newRec = { id: '', display_name: '', ps: '', rate: { id: '', display_name: '', kashidashi_rate: '' }, type: { id: '', display_name: '' } };
      // レートのレコード
      let newRate = { id: '', display_name: '', kashidashi_rate: '' };
      // タイプのレコード
      let newType = { id: '', display_name: '' };

      // レートのレコードが存在する場合
      if (data[i].rate != null) {
        newRate.id = convertData(data[i].rate['id']);
        newRate.display_name = convertData(data[i].rate['display_name']);
        newRate.kashidashi_rate = convertData(data[i].rate['kashidashi_rate']);
      }
      // タイプのレコードが存在する場合
      if (data[i].type != null) {
        newType.id = convertData(data[i].type['id']);
        newType.display_name = convertData(data[i].type['display_name']);
      }
      newRec.id = convertData(data[i].id);
      newRec.display_name = convertData(data[i].display_name);
      newRec.ps = convertData(data[i].ps);
      newRec.rate = newRate;
      newRec.type = newType;
      newData.push(newRec);
    }
    return newData;
  }
}


/**
 * undifined の場合は空文字を返す
 * @param {*} value
 */
export function convertData(value) {

  if (value == null) {
    return '';
  } else {
    return value;
  }
}

/**
 * 機種IDが機種名リストに存在するかチェック
 * @param {*} kishuNameList
 * @param {*} kishu
 */
export function checkKishuId(kishuNameList, kishu) {

  let kishuId = null;

  if (kishuNameList.data.length !== 0) {

    kishuId = kishuNameList.data.filter((item) => {
      return (item.id == kishu);
    });

    if (kishuId == null || kishuId.length === 0) {
      kishuId = kishuNameList.data[0].id;
    } else {
      kishuId = kishu;
    }
  }
  return kishuId;
}


/**
 * 機種変更前の選択期間が、機種変更後の期間範囲に含まれているかチェック
 * @param {*} termData
 * @param {*} term
 */
export function checkTermData(termData, term, kikanUnit) {
  let termId = null;

  if (termData.length !== 0) {

    // 1日を選択している場合
    if (kikanUnit == 'days') {
      termId = termData.filter((item) => {
        return (item.id == term);
      });

      if (termId == null || termId.length === 0) {
        termId = null;
      } else {
        termId = termId[0].id;
      }
    }

    // 週間を選択している場合
    if (kikanUnit == 'weeks') {
      termId = termData.filter((item) => {
        return (item.id == term);
      });

      if (termId == null || termId.length === 0) {
        termId = null;
      } else {
        termId = termId[0].id;
      }
    }

    // 月間を選択している場合
    if (kikanUnit == 'months') {
      termId = termData.filter((item) => {
        let yearMonth = item.from_date.substr(0, 7);
        return (yearMonth == term);
      });

      if (termId == null || termId.length === 0) {
        termId = null;
      } else {
        termId = termId[0].id;
      }
    }

    // 機種別では年を選択できないため
    // 年を選択時の処理は不要

  }
  return termId;
}

/**
 * K008, K009 ,K010 の機種リストのパラメータ設定
 * タイプが 'すべて', ブランドが'すべて', 納品開始日が'全期間'の場合
 * パラメータに指定しないように設定する。または
 * 機種別画面遷移の場合、選択機種の納品開始日を設定する。
 * 機種リスト取得のために パラメータを設定する。
 * @param {*} state
 * @param {*} latestNohin
 */
export function getParamKishuWithNohinFromTo(state, latestNohinFrom, latestNohinTo) {
  let param = {};

  if (state.type != 0) {
    param['type'] = state.type;
  }
  if (state.maker != 0) {
    param['brand'] = state.maker;
  }
  if (latestNohinFrom) {
    param['nohinkaishi_from'] = latestNohinFrom;
  }
  if (latestNohinTo) {
    param['nohinkaishi_to'] = latestNohinTo;
  }
  if (state.yugitype !== '' && state.pskubun == 0) {
    param['yugi_type'] = state.yugitype;
  }
  if (state.smartYugiki !== '' && state.smartYugiki != null) {
    param['smart_flag'] = state.smartYugiki;
  }
  return param;
}

/**
 * numberFormat
 * @param {*} number フォーマットする数字
 * @param {*} decimals 小数点以下桁数
 */
export function numberFormat(number, decimals) {

  if (typeof number === 'string') {
    if (number.indexOf('以下') != -1) return number;
    if (number.indexOf('未満') != -1) return number;
    if (number.indexOf('表示対象外') != -1) return number;
    if (number.search(/^(\+|-)?[0-9]+\.?[0-9]*$/) == -1) return '-';
  } else if (typeof number !== 'number') {
    return '-';
  }

  const returnNum = Highcharts.Highcharts.numberFormat(number, decimals, '.', ',');
  if (returnNum === '-0') {
    return '0';
  } else if (returnNum === '-0.00') {
    return '0.00';
  } else {
    return returnNum;
  }
}

/**
 * normalizeData（数値化できない文字列はnull）
 * @param {*} arr 数値化する配列
 */
export function normalizeData(arr) {
  return arr.map((val) => {
    const num = Number(val);
    return isNaN(num) ? null : num;
  });
}

/**
 * getUniqueStr
 */
export function getUniqueStr() {
  const resultLength = 10;
  const pattern = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const pattrtnlength = pattern.length;
  let result = '';
  for (let i = 0; i < resultLength; i++) {
    result += pattern[Math.floor(Math.random() * pattrtnlength)];
  }
  return result;
}

/**
 * ローディングアイコン（更新時）をフェードインする
 */
export function loadingFadeIn() {
  if ($('#loading').css('display') == 'none') {
    $('#loading').fadeIn(0);
    $('input').prop('disabled', true);
    $('select:not(#searchKishu)').prop('disabled', true);
  }
}

/**
 * ローディングアイコン(PC⇔タブレット切り替え時)をフェードインする
 */
export function loadingResizeFadein() {
  $('#loadingResize').fadeIn(0);
}

/**
 * ローディングアイコン（更新時）をフェードアウトする
 */
export function loadingFadeOut() {
  if ($('#loading').css('display') != 'none') {
    $('#loading').fadeOut(1000);
    $('input').prop('disabled', false);
    $('select:not(#searchKishu)').prop('disabled', false);
  }
}

/**
 * 横スクロールの位置調整
 */
/**
 * 現在のスクロール位置の入手
 */
export function getScrollLeft() {
  return $('.ledger_sheet_scroll').scrollLeft();
}
/**
 * スクロール位置を設定
 */
export function setScrollLeft(position) {
  if (position < 0) {
    return;
  }
  $('.ledger_sheet_scroll').scrollLeft(position);
}
/**
 * 現在のスクロール位置の入手
 */
export function getScrollLeftMain() {
  return $('.ledger_sheet_scroll_main').scrollLeft();
}
/**
 * 現在のスクロール位置の入手(機種グリッド)
 */
export function getScrollLeftKisyu() {
  return $('.ledger_sheet_scroll_kisyu').scrollLeft();
}
/**
 * スクロール位置を設定(k011)
 */
export function setScrollLeftK011(positionMainGrid, positionKisyuGrid) {
  let maxScrollLeftMain = positionMainGrid;
  let maxScrollLeftKisyu = positionKisyuGrid;

  if (!Number.isNaN(positionMainGrid) && positionMainGrid > 0) {
    $('.ledger_sheet_scroll_main').scrollLeft(maxScrollLeftMain);
  }
  if (!Number.isNaN(positionKisyuGrid) && positionKisyuGrid > 0) {
    $('.ledger_sheet_scroll_kisyu').scrollLeft(maxScrollLeftKisyu);
  }
}

/**
 * 最大スクロール領域を取得する
 * @param {*} jQueryElement : $('.xxx')
 * @returns
 */
export function getScrollMaxLeft(element) {
  if (element.length) {
    return element[0].scrollWidth - element.outerWidth() + 100;
  }
  return 99999;
}

/**
 * 週番号取得
 * @param {*} date
 */
export function getWeekNo(date) {
  return $.datepicker.iso8601Week(date);
}

/**
 * 年週取得
 * @param {*} date
 */
export function getYearWeek(date) {
  const thursday = new Date(date); // 木曜日が属する年を使用する
  if (thursday.getDay() !== 4) { // 木曜日以外の場合は、木曜日にする
    let offset = 0;
    if (thursday.getDay() === 1) offset = 3; // 月曜日(1) +3日
    if (thursday.getDay() === 2) offset = 2; // 火曜日(2) +2日
    if (thursday.getDay() === 3) offset = 1; // 水曜日(3) +1日
    if (thursday.getDay() === 5) offset = -1; // 金曜日(5) -1日
    if (thursday.getDay() === 6) offset = -2; // 土曜日(6) -2日
    if (thursday.getDay() === 0) offset = -3; // 日曜日(0) -3日
    thursday.setDate(thursday.getDate() + offset);
  }

  const year = String(thursday.getFullYear());
  const week = String(getWeekNo(thursday)).padStart(2, '0');
  return `${year}-W${week}`;
}

/**
 * 年月取得
 * @param {*} date
 */
export function getYearMonth(date) {
  const thursday = new Date(date); // 木曜日が属する年を使用する
  if (thursday.getDay() !== 4) { // 木曜日以外の場合は、木曜日にする
    let offset = 0;
    if (thursday.getDay() === 1) offset = 3; // 月曜日(1) +3日
    if (thursday.getDay() === 2) offset = 2; // 火曜日(2) +2日
    if (thursday.getDay() === 3) offset = 1; // 水曜日(3) +1日
    if (thursday.getDay() === 5) offset = -1; // 金曜日(5) -1日
    if (thursday.getDay() === 6) offset = -2; // 土曜日(6) -2日
    if (thursday.getDay() === 0) offset = -3; // 日曜日(0) -3日
    thursday.setDate(thursday.getDate() + offset);
  }

  const year = String(thursday.getFullYear());
  const month = String(thursday.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

/**
 * APIのパラメータ取得
 * @param {*} state
 * @param {*} param
 */
export function getParamAdditional(state, param) {
  if (state.gouki != '' && state.gouki != null) {
    param['gouki'] = state.gouki;
  }
}

/**
 * APIのパラメーターを取得(スマート遊技機)
 * @param {*} state
 * @param {*} param
 */
export function getParamSmartYugiki(state, param) {
  if (state.smartYugiki !== '' && state.smartYugiki != null) {
    param['smart_flag'] = state.smartYugiki;
  }
}

/**
 * 画面に表示する値を取得
 * @param {*} val
 * @param {*} decimals
 */
export function getDispVal(val, decimals) {
  let ret = '-';
  if (val != undefined && val != '') {
    ret = numberFormat(val, decimals);
  }
  return ret;
}

/**
 * 画面に表示する値がマイナス
 * @param {*} val
 */
export function getMinusCls(val) {
  if (parseFloat(val) < 0.0) {
    return 'minus_value';
  }
  return '';
}

/**
 * DeepCopy
 * @param {*} obj
 * @returns
 */
export function deepCopy(obj) {
  if (obj === null || typeof obj !== 'object') return obj; // 基本型はそのまま返す

  if (Array.isArray(obj)) return obj.map(item => this.deepCopy(item)); // 配列の場合は再帰的にコピー

  const newObj = {};
  for (let key in obj) {
    newObj[key] = this.deepCopy(obj[key]); // オブジェクトの場合も再帰的にコピー
  }

  return newObj;
}

/**
 * URLパラメータを配列で取得する
 */
function getQueryString() {
  if (1 < document.location.search.length) {
    const query = document.location.search.substring(1); // 最初の1文字 (?記号) を除いた文字列を取得する
    const parameters = query.split('&'); // クエリの区切り記号 (&) で文字列を配列に分割する

    let result = {};
    for (let i = 0; i < parameters.length; i++) {
      // パラメータ名とパラメータ値に分割する
      const element = parameters[i].split('=');

      const paramName = decodeURIComponent(element[0]);
      const paramValue = decodeURIComponent(element[1]);

      // パラメータ名をキーとして連想配列に追加する
      result[paramName] = decodeURIComponent(paramValue);
    }
    return result;
  }
  return null;
}

/**
 * アンカーパラメータを配列で取得する
 */
function getAnchorString() {
  if (1 < document.location.hash.length) {
    // 最初の1文字 (?記号) を除いた文字列を取得する
    let query = document.location.hash.substring(1);

    // クエリの区切り記号 (&) で文字列を配列に分割する
    let parameters = query.split('&');

    let result = {};
    for (let i = 0; i < parameters.length; i++) {
      // パラメータ名とパラメータ値に分割する
      let element = parameters[i].split('=');

      let paramName = decodeURIComponent(element[0]);
      let paramValue = decodeURIComponent(element[1]);

      // パラメータ名をキーとして連想配列に追加する
      result[paramName] = decodeURIComponent(paramValue);
    }
    return result;
  }
  return null;
}

/**
 * 期間データの整形
 * @param {*} dateList
 */
export function getDateList(dateList) {
  const transformedDateList = dateList.map((date) => {
    // 日付形式の判定
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      // 日フォーマット (yyyy-mm-dd)
      const [, month, day] = date.split('-');
      return `${parseInt(month, 10)}/${parseInt(day, 10)}`;
    } else if (/^\d{4}-W\d{2}$/.test(date)) {
      // 週フォーマット (yyyy-Wxx)
      const [year, week] = date.split('-W').map(Number);
      const firstMonday = new Date(year, 0, 1);
      const dayOffset = (firstMonday.getDay() <= 4 ? 1 - firstMonday.getDay() : 8 - firstMonday.getDay());
      firstMonday.setDate(firstMonday.getDate() + dayOffset + (week - 1) * 7);
      return `${firstMonday.getMonth() + 1}/${firstMonday.getDate()}～`;
    } else if (/^\d{4}-\d{2}$/.test(date)) {
      // 月フォーマット (yyyy-mm)
      return date.replace('-', '/');
    } else if (/^\d{4}$/.test(date)) {
      // 年フォーマット (yyyy)
      return date;
    } else {
      // 不明な形式の場合はそのまま返す
      return date;
    }
  });

  return transformedDateList;
}

/**
 * targetDateがFromToの範囲内であればtrueを返す
 * @param {Date} date from or to date
 * @param {Date} targetDate 判定する日付
 * @param {string} viewMode
 * @param {bool} isFromDatePicker
 * @returns
 */
export function isDateInFromToRange(date, targetDate, viewMode, isFromDatePicker) {
  let tgtDate = new Date(targetDate);
  let compareDate = new Date(date);
  if (viewMode === 'day') {
    tgtDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
    compareDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return isFromDatePicker
      ? tgtDate.getFullYear() < compareDate.getFullYear() ||
        tgtDate.getFullYear() === compareDate.getFullYear() && tgtDate.getMonth() < compareDate.getMonth() ||
        tgtDate.getFullYear() === compareDate.getFullYear() && tgtDate.getMonth() === compareDate.getMonth() && tgtDate.getDate() <= compareDate.getDate()
      : compareDate.getFullYear() < tgtDate.getFullYear() ||
        compareDate.getFullYear() === tgtDate.getFullYear() && compareDate.getMonth() < tgtDate.getMonth() ||
        compareDate.getFullYear() === tgtDate.getFullYear() && compareDate.getMonth() === tgtDate.getMonth() && compareDate.getDate() <= tgtDate.getDate();
  } else if (viewMode === 'month') {
    tgtDate = new Date(targetDate.getFullYear(), targetDate.getMonth());
    compareDate = new Date(date.getFullYear(), date.getMonth());
    return isFromDatePicker
      ? tgtDate.getFullYear() < compareDate.getFullYear() ||
        tgtDate.getFullYear() === compareDate.getFullYear() && tgtDate.getMonth() <= compareDate.getMonth()
      : compareDate.getFullYear() < tgtDate.getFullYear() ||
        compareDate.getFullYear() === tgtDate.getFullYear() && compareDate.getMonth() <= tgtDate.getMonth();
  } else if (viewMode === 'year') {
    tgtDate = new Date(targetDate.getFullYear());
    compareDate = new Date(date.getFullYear());
    return isFromDatePicker
      ? tgtDate.getFullYear() <= compareDate.getFullYear()
      : compareDate.getFullYear() <= tgtDate.getFullYear();
  }
  return false;
}

/**
 * 納品時期カレンダーにおいて、有効な日付の場合はtrueを返却する
 * 有効とは、納品データにある日付 かつ FromTo指定の範囲内であること
 */
export function isActiveOnNohinCalendar(targetDate, viewMode, nohinTermData, nohinFrom, nohinTo, isFromCalendar) {
  if (!targetDate) {
    return false;
  }

  return nohinTermData.data.some((item) => {
    const nohinkaishibiDate = new Date(item.model.nohinkaishibi);
    let isDateInRange = false;
    if (viewMode === 'day') {
      // 日付で判定
      isDateInRange = nohinkaishibiDate.getFullYear() === targetDate.getFullYear() &&
        nohinkaishibiDate.getMonth() === targetDate.getMonth() &&
        nohinkaishibiDate.getDate() === targetDate.getDate();
    } else if (viewMode === 'month') {
      // 月で判定
      isDateInRange = nohinkaishibiDate.getFullYear() === targetDate.getFullYear() &&
        nohinkaishibiDate.getMonth() === targetDate.getMonth();
    } else if (viewMode === 'year') {
      // 年で判定
      isDateInRange = nohinkaishibiDate.getFullYear() === targetDate.getFullYear();
    }
    if (isDateInRange) {
      // From, Toの日付を考慮する
      if (!isFromCalendar && nohinFrom) {
        // Toカレンダーの場合はFromカレンダーの日付以降の日付を有効化する
        const nohinFromDate = createDateByViewMode(nohinFrom, viewMode);
        isDateInRange = isDateInFromToRange(nohinFromDate, targetDate, viewMode, false);
      } else if (isFromCalendar && nohinTo) {
        // Fromカレンダーの場合はToカレンダーの日付以前の日付を有効化する
        const nohinToDate = createDateByViewMode(nohinTo, viewMode);
        isDateInRange = isDateInFromToRange(nohinToDate, targetDate, viewMode, true);
      }
    }
    return isDateInRange;
  });
}

function createDateByViewMode(date, viewMode) {
  if (viewMode === 'day') {
    return new Date(date);
  } else if (viewMode === 'month') {
    return new Date(date.slice(0, 7));
  } else if (viewMode === 'year') {
    return new Date(date.slice(0, 4));
  }
}


export function getStartDate(isNohinCalendar, termData) {
  if (isNohinCalendar) {
    // 納品時期カレンダーの場合、2010年1月1日を起点とする
    return new Date('2010-01-01T00:00:00');
  } else {
    // 期間カレンダーの場合
    return new Date(termData[0].from_date);
  }
}

export function getEndDate(isNohinCalendar, nohinTermData, termData) {
  if (isNohinCalendar) {
    // 納品時期カレンダーの場合
    const nohinData = nohinTermData.data;
    // 納品データは納品開始日の降順なので最初のデータが新しい日付となる
    return new Date(nohinData[0].model.nohinkaishibi);
  } else {
    // 期間カレンダーの場合
    return new Date(termData[termData.length - 1].to_date);
  }
}

/**
 * 期間カレンダーの場合に、日付をDate型にフォーマットして返却する
 */
export function formatTermToDate(term, viewMode, kikanUnit, termData) {
  if (viewMode === 'day') {
    if (kikanUnit === 'weeks') {
      const targetData = termData.find(item => item.id === term);
      return new Date(targetData.to_date);
    }
    return new Date(term);
  } else if (viewMode === 'month') {
    return new Date(term.slice(0, 7));
  } else if (viewMode === 'year') {
    return new Date(term.slice(0, 4));
  }
}

/**
 * 対象の期間値(termId)から開始日を取得する
 *
 * @param {string} targetTerm 変換対象の期間値(YYYY-MM-DD, YYYY-W99, YYYY-MM, YYYY)
 * @param {string} kikanUnit 期間種別
 */
export function formatTermStartEndById(targetTerm, kikanUnit) {
  let formatTermStart;
  let formatTermEnd;
  let termFromToList;
  switch (kikanUnit) {
    case 'days':
      formatTermStart = `${targetTerm}T00:00:00+09:00`;
      formatTermEnd = `${targetTerm}T00:00:00+09:00`;
      break;
    case 'weeks':
      termFromToList = getWeekStartAndEnd(targetTerm, 7, 3);
      formatTermStart = `${termFromToList[0]}T00:00:00+09:00`;
      formatTermEnd = `${termFromToList[termFromToList.length - 1]}T00:00:00+09:00`;
      break;
    case 'months':
      formatTermStart = `${new Date(targetTerm).setDate(1)}T00:00:00+09:00`;
      formatTermEnd = `${new Date(new Date(targetTerm).getFullYear(), new Date(targetTerm).getMonth() + 1, 0)}T00:00:00+09:00`;
      break;
    case 'years':
      formatTermStart = `${targetTerm}-01-01T00:00:00+09:00`;
      formatTermEnd = `${targetTerm}-12-31T00:00:00+09:00`;
      break;
    default:
      break;
  }

  return { [FROM_DATE_KEY]: formatTermStart, [TO_DATE_KEY]: formatTermEnd };
}

/**
 * 指定した期間の前期間・後期間を算出
 *
 * @param {*} targetTerm termId(YYYY-MM, YYYY-W99, YYYY-MM, YYYY)
 * @param {*} offset 算出するN期間(正数: 後期間, 負数: 前期間)
 * @param {*} kikanUnit 期間種類(days, weeks, months, years)
 * @returns
 */
export function getTargetDirectionTerm(targetTerm, offset, kikanUnit) {

  function getDay(targetTerm, offset) {
    const date = new Date(targetTerm);
    date.setDate(date.getDate() + offset);
    return date.toISOString().split('T')[0];
  }

  function getWeek(targetTerm, offset) {
    const [year, week] = targetTerm.split('-W').map(Number);
    const firstDayOfYear = new Date(Date.UTC(year, 0, 1));
    const dayOfWeek = firstDayOfYear.getUTCDay() || 7; // Sunday as 7
    const daysToFirstWeek = 8 - dayOfWeek;
    const firstIsoWeekDate = new Date(Date.UTC(year, 0, daysToFirstWeek));
    const targetDate = new Date(firstIsoWeekDate);
    targetDate.setUTCDate(targetDate.getUTCDate() + (week - 1) * 7 + offset * 7);

    const resultYear = targetDate.getUTCFullYear();
    const firstDayOfResultYear = new Date(Date.UTC(resultYear, 0, 1));
    const firstResultDayOfWeek = firstDayOfResultYear.getUTCDay() || 7;
    const resultFirstIsoWeekDate = new Date(Date.UTC(resultYear, 0, 8 - firstResultDayOfWeek));
    const daysFromFirstWeek = Math.floor((targetDate - resultFirstIsoWeekDate) / (24 * 60 * 60 * 1000));
    const resultWeek = Math.floor(daysFromFirstWeek / 7) + 1;

    return `${resultYear}-W${String(resultWeek).padStart(2, '0')}`;
  }

  function getMonth(targetTerm, offset) {
    const [year, month] = targetTerm.split('-').map(Number);
    const date = new Date(year, month - 1); // JavaScript months are 0-based
    date.setMonth(date.getMonth() + offset);
    const resultYear = date.getFullYear();
    const resultMonth = date.getMonth() + 1; // Convert back to 1-based
    return `${resultYear}-${String(resultMonth).padStart(2, '0')}`;
  }

  function getYear(targetTerm, offset) {
    const year = Number(targetTerm);
    return String(year + offset);
  }

  if (kikanUnit === 'days') {
    return getDay(targetTerm, offset);
  }
  if (kikanUnit === 'weeks') {
    return getWeek(targetTerm, offset);
  }
  if (kikanUnit === 'months') {
    return getMonth(targetTerm, offset);
  }
  if (kikanUnit === 'years') {
    return getYear(targetTerm, offset);
  }

  return '';
}

/**
 * 表示する値のステータス変更制御
 * @param {*} list
 * @param {*} key
 * @param {*} status
 * @returns
 */
export function changeDisplayItemShow(list, key, status) {
  const displayItems = list.map((item) => {
    if (item.key === key) {
      item.isShow = status;
    }
    return item;
  });

  return displayItems;
}

/**
 * テキスト省略処理
 *
 * @param {*} text
 * @param {*} limit
 */
export function ellipsisText(text, limit) {
  if (text.length <= limit) {
    return text;
  }
  return text.slice(0, limit) + '…';
}

/**
 * ページトップアイコン表示・非表示切り替え
 * @param {*} isShow
 */
export function switchPageTopIconState(isShow) {
  if (isShow) {
    $('#page_top_content').show();
  } else {
    $('#page_top_content').hide();
  }
}

/**
 * 中古価格リンク押下イベント制御
 *
 * @param {*} event 押下イベント
 * @param {*} kishuCode P-SENSOR機種コード
 */
export function handleUsedMachinePriceClick(event, kishuCode) {
  event.preventDefault();

  if (kishuCode == null || kishuCode == undefined || kishuCode == '') {
    // 機種コードが存在しない場合は処理終了
    console.log('kishu code is empty');
    return;
  }

  // Auth0のアクセストークン取得
  const accessToken = cookies.getItem('access_token');
  if (accessToken == null || accessToken == undefined) {
    // アクセストークンが存在しない場合はエラーに遷移
    console.log('userinfo does not exist in cookies');
    javascript_die();
  }
  const param = {};
  param['X-Kitac-AuthToken'] = accessToken;

  // Auth0のアクセストークン取得
  const psensorTokenInfo = sessionStorage.getItem('psensorToken');
  if (psensorTokenInfo == null || psensorTokenInfo == undefined) {
    // アクセストークンが保持されていない場合は取得APIを実行する
    getPsensorToken(param, kishuCode);
  } else {
    const psensorTokenMap = JSON.parse(psensorTokenInfo);
    const savedDate = psensorTokenMap.savedDate;
    const token = psensorTokenMap.token;
    // 現在日時(YYYY/MM/DD)を取得する
    const now = toLocaleString(new Date());
    if (savedDate != now) {
      // アクセストークンが保持されているが、現在日付と取得時の日付が異なる場合は取得APIを実行する
      getPsensorToken(param, kishuCode);
    } else {
      showPSensorPage(token, kishuCode);
    }
  }
}

/**
 * PSENSORのアクセストークン取得
 *
 * @param {*} param リクエストパラメータ群
 * @param {*} kishuCode 機種コード
 */
function getPsensorToken(param, kishuCode) {
  apiWrapper.getPsensorToken(param, (err, res) => {
    if (err) {
      console.log('get psensor token error: ' + err);
      javascript_die();
    } else {
      if (res.access_token == null || res.access_token == undefined) {
        console.log('psensor token does not exist in response');
        javascript_die();
      } else {
        // p-sensorのアクセストークンをセッションストレージに格納する
        const psensorToken = { savedDate: toLocaleString(new Date()), token: res.access_token };
        sessionStorage.setItem('psensorToken', JSON.stringify(psensorToken));
        // P-SENSORのアクセストークンが取得成功した場合、ページを表示する
        showPSensorPage(res.access_token, kishuCode);
      }
    }
  });
}

/**
 * P-SENSORページを表示
 *
 * @param {*} accessToken アクセストークン
 * @param {*} kishuCode 機種コード
 */
function showPSensorPage(accessToken, kishuCode) {
  sessionStorage.setItem('access_token', accessToken);
  sessionStorage.setItem('page', '2');
  sessionStorage.setItem('kisyu_cd', kishuCode);
  sessionStorage.setItem('action_url', PSENSOR_URL_AUTO_LOGIN);

  window.open('../psensor/kishu_detail.html', '_blank');
}

/**
 * K015_シン機種ページ遷移用URLを作成
 *
 * @param {*} paramList パラメータリスト
 */

export function getUrlParam(paramList) {
  let param = '../K015/index.html?';
  for (let i = 0; i < paramList.length; i++) {
    if (i == 0) {
      param += paramList[0];
    } else {
      param += '&' + paramList[i];
    }
  }
  return param;
}

/**
 * callback API を Promise 化
 *
 * @param {*} apiFunc API
 * @param {*} params APIリクエストパラメータ
 */
export function toPromise(apiFunc, params) {
  return new Promise((resolve, reject) => {
    apiFunc(params, (err, res) => {
      if (err) reject(err);
      else resolve(res);
    });
  });
}

/**
 * callback API を Promise 化（APIリクエストパラメータなし）
 *
 * @param {*} apiFunc API
 */
export function toPromiseNoArgs(apiFunc) {
  return new Promise((resolve, reject) => {
    apiFunc((err, res) => {
      if (err) reject(err);
      else resolve(res);
    });
  });
}

/**
 * ブラウザのテーマカラー変更イベント
 */
export function changeTheme() {
  const root = document.documentElement;
  const currentMode = root.getAttribute('data-color-scheme-mode');
  const newMode = currentMode === 'light' ? 'dark' : 'light';
  root.setAttribute('data-color-scheme-mode', newMode);

  // ユーザー情報を取得
  const userId = cookies.getItem('userId');
  // ストレージへの保存
  const savedKey = 'BROWSE_THEME_COLOR_' + userId;
  localStorage.setItem(savedKey, newMode);
}

/**
 * ブラウザのテーマカラーを取得
 * @returns dark, light
 */
export function getBrowseThemeColor() {
  // ブラウザのテーマカラー取得
  const userId = cookies.getItem('userId');
  let theme = localStorage.getItem('BROWSE_THEME_COLOR_' + userId);
  if (theme == null || theme == undefined || theme == '') {
    // ストレージに保存されていない場合はChromeの設定に従う;
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    theme = prefersDark ? 'dark' : 'light';
  }

  return theme;
}
